"use strict";

exports.__esModule = true;
exports.nearestIndexInPageSizeList = exports.getDefaultSortOrder = exports.getDefaultPageSize = exports.getDefaultFilters = void 0;
var _DataTable = require("../../Core/DataTable");
var _unformatter = require("../DataTable/Formatters/unformatter");
var getDefaultSortOrder = exports.getDefaultSortOrder = function getDefaultSortOrder(columns) {
  return columns.reduce(function (acc, col) {
    if (col.enableSorting && (col.defaultSortOrder === "ASC" || col.defaultSortOrder === "DESC")) {
      var id = col.id;
      var desc = col.defaultSortOrder.toLowerCase() === "desc";
      acc.push({
        id: id,
        desc: desc,
        property: id,
        direction: col.defaultSortOrder ? col.defaultSortOrder.toLowerCase() : "desc"
      });
    }
    return acc;
  }, []);
};
var getDefaultFilters = exports.getDefaultFilters = function getDefaultFilters(columns, contexts) {
  return columns.reduce(function (acc, col) {
    if (!!col.canFilter && !!col.defaultFilterValue) {
      var id = col.id;
      var unformattedValue = (0, _unformatter.unformatter)(col.type, col.defaultFilterValue, contexts);
      if (col.exactMatch === false) {
        acc.push({
          id: id,
          value: unformattedValue
        });
        return acc;
      }

      /* Some cells in React-table are rendered as numbers and some as strings */
      acc.push({
        id: id,
        value: !!parseInt(unformattedValue) ? [unformattedValue, parseInt(unformattedValue)] : [unformattedValue]
      });
    }
    return acc;
  }, []);
};
var nearestIndexInPageSizeList = exports.nearestIndexInPageSizeList = function nearestIndexInPageSizeList(pageSizes, defaultValue) {
  var sizes = pageSizes.map(function (size) {
    return Math.abs(defaultValue - size);
  });
  var leastIndexPair = [0, Infinity];
  sizes.forEach(function (size, idx) {
    if (size < leastIndexPair[1]) {
      leastIndexPair = [idx, size];
    }
  });
  return pageSizes[leastIndexPair[0]];
};
var getDefaultPageSize = exports.getDefaultPageSize = function getDefaultPageSize(configuration, height) {
  return configuration && typeof configuration.defaultPageSize === "number" ? configuration.defaultPageSize : (0, _DataTable.calculateRowsForHeight)(height);
};